import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface HashCardRootProps extends ComponentProps<'div'> {}

export function HashCardRoot({ className, ...props }: HashCardRootProps) {
  return (
    <div
      className={twMerge(
        'flex flex-col items-start gap-3 rounded-lg bg-white p-4',
        className,
      )}
      {...props}
    />
  )
}
